import Vue from 'vue';
import App from '@/listing-app/App.vue';
import Api from '@/listing-app/api'
import Router from '@/listing-app/router';
import Store from '@/listing-app/store';
import Blue from '../js/core';

Vue.config.devtools = true
Vue.config.productionTip = false

Vue.prototype.$api = new Api

new Blue({
	name: 'listing-app',
	selector: '#listing-app',
	setup(el) {
		const app = new Vue({
			router: Router,
			store: Store,
			data: () => Object.assign({}, el.dataset),
			render: h => h(App)
		});
		app.$mount(el)
	}
}, false)